import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'

export default class TWorkshiftDM extends Data {
	public static className = 'TWorkshiftDM'
	public static primaryKey = 'RID'
	public static systemFields = [
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	IsShiftEndDate?: string
	Description?: string
	Abbr?: string
	RID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
}